// "New buyer message: a new draft is available" (2026-10-13). Ingest now
// regenerates an OPEN contact when a new buyer message arrives. If the agent
// has the contact open with unsaved draft or step edits when that new
// suggestion lands, the panel keeps their edits and shows this notice with a
// "Load new draft" button, instead of swapping the suggestion underneath them.
export const NEW_DRAFT_NOTICE_TEXT = 'New buyer message: a new draft is available'
// The same notice for a newer suggestion the agent chose to keep their work
// over (2026-10-27, "Keep my work" / "Keep my saved work" in the "A new
// suggestion is ready" dialog) when no new customer message is behind it, e.g. a Regenerate.
export const NEW_SUGGESTION_NOTICE_TEXT = 'A new suggestion is available'

export function newDraftNoticeText(current, newer) {
  const id = newer?.triggerMessageId
  return id && id !== current?.triggerMessageId ? NEW_DRAFT_NOTICE_TEXT : NEW_SUGGESTION_NOTICE_TEXT
}

// Hold (don't apply) a refreshed suggestion when it answers a DIFFERENT buyer
// message than the one shown and the agent has unsaved edits. A refresh for
// the same turn (a manual action's regenerate, an intent override) keeps
// today's behavior: applied, with the agent's edits kept.
export function shouldHoldNewerSuggestion({ current, latest, dirty }) {
  if (!dirty || !current || !latest) return false
  if (latest.id === current.id) return false
  return Boolean(latest.triggerMessageId) && latest.triggerMessageId !== current.triggerMessageId
}

// The server refused a Send / Close / Spam / Process because the suggestion
// was replaced by a newer one: a 409 'superseded' (Process), or a 409
// already_decided whose suggestion was decided by system:superseded.
export function isSupersededError(e) {
  if (e?.status !== 409) return false
  return e.body?.error === 'superseded' || e.body?.suggestion?.decidedBy === 'system:superseded'
}
